<template>
  <div class="popupWiedervorlage">
    <Popup :header="header" @accept="acceptAndClose()" @abort="closePopup()">
      <template v-slot:content>
        <v-row>
          <v-col>
            <v-combobox
                label="Interne Teilnehmer"
                :items="verfuegbareTeilnehmer"
                v-model="teilnehmer"
                :item-text="item => item.vorname + ' ' + item.nachname"
                multiple
                outlined
                dense
                hideDetails="auto"
            />
            <!--
            <b-select
              label="Interne Teilnehmer"
              :items="verfuegbareTeilnehmer"
              v-model="teilnehmer"
              multiple
              item-text="nachname"
              item-value="id"
            />
            -->
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <b-text-field
                label="Titel"
                type="text"
                v-model="titel"
            />
          </v-col>
          <v-col>
            <b-date-field
                label="Datum"
                v-model="datum"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <b-text-area
                label="Beschreibung"
                v-model="beschreibung"
            />
          </v-col>
        </v-row>
      </template>
    </Popup>
    <v-snackbar v-model="showSnackbar" timeout="4000" color="red">
      {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import Popup from '@/components/base_components/Popup';
import axios from 'axios';
import dataMixin from "@/mixins/data-mixin";

export default {
  name: 'WiedervorlagePopup',
  components: { Popup },
  props: {
    projektId: {
      type: String,
      required: true,
    },
    wiedervorlage: Object,
  },
  data() {
    return {
      verfuegbareTeilnehmer: [],
      showSnackbar: false,
      snackbarMessage: '',
      wiedervorlageGeladen: null,
    };
  },
  mixins: [
    dataMixin('teilnehmer', 'persistentData.teilnehmer'),
    dataMixin('titel', 'persistentData.titel'),
    dataMixin('datum', 'persistentData.datum'),
    dataMixin('beschreibung', 'persistentData.beschreibung'),
  ],
  computed: {
    header() {
      return this.wiedervorlageId ? 'Wiedervorlage bearbeiten' : 'Neue Wiedervorlage';
    }
  },
  methods: {
    closePopup() {
      this.$emit('close');
    },
    acceptAndClose() {
      let wiedervorlage = {
        projektID: this.projektId,
        mitarbeiter: this.teilnehmer,
        titel: this.titel,
        datum: this.datum,
        beschreibung: this.beschreibung
      };
      if (this.wiedervorlageGeladen) {
        wiedervorlage.id = this.wiedervorlage.id;
        wiedervorlage.projektId = this.projektId;
        delete wiedervorlage.projektID;
        axios.put('/v1/wiedervorlage', wiedervorlage)
            .then(() => {
              this.$emit('save');
              this.closePopup();
            })
            .catch((error) => {
              this.showSnackbar = true;
              this.snackbarMessage = error.response.data;
            });
      } else {
        axios.post('/v1/wiedervorlage', wiedervorlage)
            .then(() => {
              this.$emit('save');
              this.closePopup();
            })
            .catch((error) => {
              this.showSnackbar = true;
              this.snackbarMessage = error.response.data;
            });
      }
    },
    ladeVerfuegbareTeilnehmer() {
      axios.get('/v1/mitarbeiter')
        .then((response) => {
          this.verfuegbareTeilnehmer = response.data;
        });
    },
    ladeWiedervorlage() {
      const params = {
        id: this.wiedervorlage.id
      };
      axios.get('/v1/wiedervorlage', { params })
        .then((response) => {
          this.wiedervorlageGeladen = true;
          this.teilnehmer = response.data.mitarbeiter;
          this.titel = response.data.titel;
          this.datum = response.data.datum;
          this.beschreibung = response.data.beschreibung;
        });
    },
  },
  created() {
    this.ladeVerfuegbareTeilnehmer();
    if (this.wiedervorlage) {
      this.ladeWiedervorlage();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
